import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import {ActionButton} from './action-button';

@observer
export default class ActionButtonRenderer extends React.Component {

  static propTypes = {
    children: PropTypes.array.isRequired,
    status: PropTypes.oneOf(['APPROVED', 'DRAFT', 'INACTIVE', 'INACTIVE - Expired Certificate', 'LIVE', 'REJECTED', 'UNDER_REVIEW', 'WITHDRAWN']),
    className: PropTypes.string
  }

  static defaultProps = {
    status: '',
    className: ''
  }

  buttonAllowedByStatus = (status, action) => {
    const statusConditions = {
      copy: [
        'APPROVED',
        'LIVE',
        'REJECTED',
        'INACTIVE',
        'INACTIVE - Expired Certificate',
        'UNDER_REVIEW',
        'WITHDRAWN'
      ],
      edit: [
        'LIVE',
        'UNDER_REVIEW',
        'APPROVED',
        'REJECTED'
      ],
      remove: [
        'LIVE'
      ],
      withdraw: [
        'UNDER_REVIEW',
        'APPROVED'
      ]
    }
    return statusConditions[action.toLowerCase()].indexOf(status) > -1;
  }

  render() {
    return (
      <div className={`action-buttons ${this.props.className}`}>
        {this.props.children.map(button => {
          const action = button.action || button.label;
          if (this.props.status && this.buttonAllowedByStatus(this.props.status, action)) {
            return <ActionButton key={button.label} {...button} />
          } else if (!this.props.status) {
            return <ActionButton key={button.label} {...button} />
          }
        })}
      </div>
    )
  }
}
